"use strict";

exports.__esModule = true;
exports.BLOCK_CODE = exports.BLOCK_VIDEO = exports.BLOCK_BUTTON = exports.BLOCK_SPACER = exports.BLOCK_IMAGE = exports.BLOCK_TEXT = exports.LINE = exports.DOCUMENT = void 0;

/** @type {DocumentJson} */
var DOCUMENT = {
  version: "1.0.0",
  config: {},
  width: 1000,
  language: "fr",
  lines: []
};
/** @type Line */

exports.DOCUMENT = DOCUMENT;
var LINE = {
  uid: "",
  backgroundType: "transparent",
  backgroundColor: "#FFFFFF",
  backgroundSrc: "",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  backgroundFillWidth: false,
  alignItems: "flex-start",
  layoutMobile: "column",
  columnsCount: 1,
  columnsPreset: "100%",
  paddingTop: 0,
  paddingRight: 0,
  paddingLeft: 0,
  paddingBottom: 0,
  columns: [[]]
};
/** @type BlockText */

exports.LINE = LINE;
var BLOCK_TEXT = {
  type: "text",
  uid: "",
  config: {},
  allowHorizontalPositioning: true,
  alignment: "flex-start",
  fullWidth: false,
  paddingTop: 0,
  paddingRight: 16,
  paddingLeft: 16,
  paddingBottom: 0,
  backgroundType: "transparent",
  backgroundColor: "#FFFFFF",
  backgroundSrc: "",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  content: {
    intl: {
      fr: {
        text: "<p>Ajoutez votre texte</p>"
      }
    }
  }
};
/** @type BlockImage */

exports.BLOCK_TEXT = BLOCK_TEXT;
var BLOCK_IMAGE = {
  type: "image",
  uid: "",
  config: {},
  allowHorizontalPositioning: true,
  alignment: "flex-start",
  fullWidth: false,
  paddingTop: 0,
  paddingRight: 16,
  paddingLeft: 16,
  paddingBottom: 0,
  backgroundType: "transparent",
  backgroundColor: "#FFFFFF",
  backgroundSrc: "",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  content: {
    intl: {
      fr: {
        source: "",
        alt: ""
      }
    }
  }
};
exports.BLOCK_IMAGE = BLOCK_IMAGE;
var BLOCK_SPACER = {
  type: "spacer",
  config: {},
  allowHorizontalPositioning: false,
  alignment: "flex-start",
  fullWidth: false,
  paddingTop: 0,
  paddingRight: 0,
  paddingLeft: 0,
  paddingBottom: 0,
  backgroundType: "transparent",
  backgroundColor: "#FFFFFF",
  backgroundSrc: "",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  content: {
    height: 32
  }
};
/** @type BlockButton */

exports.BLOCK_SPACER = BLOCK_SPACER;
var BLOCK_BUTTON = {
  type: "button",
  uid: "",
  config: {},
  allowHorizontalPositioning: true,
  alignment: "flex-start",
  fullWidth: false,
  paddingTop: 0,
  paddingRight: 16,
  paddingLeft: 16,
  paddingBottom: 0,
  backgroundType: "transparent",
  backgroundColor: "#FFFFFF",
  backgroundSrc: "",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  content: {
    paddingTop: 10,
    paddingRight: 25,
    paddingLeft: 25,
    paddingBottom: 10,
    backgroundType: "transparent",
    backgroundColor: "#FFFFFF",
    borderRadius: 3,
    borderWidth: 3,
    borderColor: "#000000",
    color: "#000",
    openInNewTab: false,
    intl: {
      fr: {
        text: "Button",
        url: "https://www.google.com"
      }
    }
  }
};
/** @type BlockVideo */

exports.BLOCK_BUTTON = BLOCK_BUTTON;
var BLOCK_VIDEO = {
  type: "video",
  uid: "",
  config: {},
  allowHorizontalPositioning: true,
  alignment: "center",
  fullWidth: false,
  paddingTop: 0,
  paddingRight: 16,
  paddingLeft: 16,
  paddingBottom: 0,
  backgroundType: "transparent",
  backgroundColor: "#000",
  backgroundSrc: "",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  content: {
    autoplay: false,
    controls: true,
    intl: {
      fr: {
        source: ""
      }
    }
  }
};
/** @type BlockCode */

exports.BLOCK_VIDEO = BLOCK_VIDEO;
var BLOCK_CODE = {
  type: "code",
  uid: "",
  config: {},
  allowHorizontalPositioning: true,
  alignment: "flex-start",
  fullWidth: false,
  paddingTop: 0,
  paddingRight: 16,
  paddingLeft: 16,
  paddingBottom: 0,
  backgroundType: "transparent",
  backgroundColor: "#FFFFFF",
  backgroundSrc: "",
  backgroundRepeat: "no-repeat",
  backgroundPosition: "center center",
  content: {
    intl: {
      fr: {
        code: ""
      }
    }
  }
};
exports.BLOCK_CODE = BLOCK_CODE;